/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { OrganizationApiService } from '../../services/OrganizationApiService';
import { ApiClientError } from '../../types/api/ApiClientError';
import { ApiClientResponse } from '../../types/api/ApiClientResponse';
import { ResponseError } from '../../types/api/ResponseError';
import { Organization } from '../../types/organization/Organization';
import { fetchOrganizationActions, fetchOrganizationsActions } from './actions';
import { FetchOrgDetailsActionWatcher, OrganizationActions } from './types';

// sagas

export function* fetchOrganizationSaga(action: FetchOrgDetailsActionWatcher) {
  const { organizationId } = action.payload;
  yield put(fetchOrganizationActions.request());
  try {
    const result: ApiClientResponse<Organization> = yield call(OrganizationApiService.fetchOrganizationById, {
      organizationId,
    });
    yield put(fetchOrganizationActions.success(result.data.payload));
  } catch (e) {
    // console.error(e);
    yield put(fetchOrganizationActions.error((e as ApiClientError<ResponseError>).response?.data.message));
  }
}

export function* fetchOrganizationsSaga() {
  yield put(fetchOrganizationsActions.request());
  try {
    const result: ApiClientResponse<Organization[]> = yield call(OrganizationApiService.fetchAllOrganizations);
    yield put(fetchOrganizationsActions.success(result.data.payload));
  } catch (e) {
    const error = e as ApiClientError;
    console.error(error);
    yield put(fetchOrganizationsActions.error(error.response?.data.error));
  }
}

// watchers

export function* organizationMainSaga(): Generator {
  yield all([
    yield takeLatest(OrganizationActions.ORG_DETAILS_WATCHER, fetchOrganizationSaga),
    yield takeLatest(OrganizationActions.ORGANIZATIONS_WATCHER, fetchOrganizationsSaga),
  ]);
}
